export const chevronPath =
  'M16.541,42.197h28.104c8.813,0,7.208,7.146,7.208,15.96	c0,8.813-7.144,15.959-15.958,15.959H25.291c-8.816,0-15.961-7.146-15.961-15.959C9.33,49.341,7.726,42.197,16.541,42.197z'

export const leftArrowPath =
  'M368.7-8.3l64.8,64.8L239.1,250.9l194.4,194.4L368.7,510L109.5,250.9L368.7-8.3z'

export const rightArrowPath =
  'M433.5,250.9L174.3,510l-64.8-64.8l194.4-194.4L109.5,56.5l64.8-64.8L433.5,250.9z'

export const jumpBgPoints = '100,44.235 0,44.255 0,90 39.936,90 50,100.064 60.064,90 100,90'

export const jumpLeftPath =
  'M0,99.042c0,0,16.97,0.025,19.096,0.057c7.953,0.115,29.658,1.045,43.779-14.789c15.369-17.231,10.287-42.979,10.287-42.979h16.264L58.004,0L26.582,41.331h16.263c0,0,2.292,11.635-2.759,19.012c-4.291,6.27-13.14,7.087-18.519,7.087C19.104,67.43,0,67.376,0,67.376V99.042z'

export const jumpRightPath =
  'M0,31.771c0,0,19.104-0.054,21.567-0.054c5.378,0,14.228,0.817,18.519,7.087c5.052,7.377,2.759,19.013,2.759,19.013H26.582l31.422,41.33l31.422-41.33H73.162c0,0,5.082-25.748-10.287-42.979C48.754-0.997,27.049-0.067,19.096,0.048C16.97,0.079,0,0.104,0,0.104V31.771z'

export const jumpStraightPath =
  'M0,67.174h50.821v18.113l46.095-34.993L50.821,15.298v18.114H0V67.174z'
